import Icon from "./IconBase.js";
const UpBlueArrowIcon = (props) => {
  return (
    <Icon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33366 10.333L8.00032 5.66634L12.667 10.333"
          stroke="#00B0F5"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default UpBlueArrowIcon;
